<app-job-pointe-list [tableData]="data" [tableFilters]="filters" [source]="data.type"> </app-job-pointe-list>

<app-job-board-card></app-job-board-card>
<app-manage-owner></app-manage-owner>
<app-add-employee-job></app-add-employee-job>
<app-edit-employee-attribute></app-edit-employee-attribute>
